import React, { useContext } from "react";

import MyRequestsTimeOff from "./time-off-list/MyRequestsTimeOff";
import SessionContext from "app/contexts/SessionContext";
import SummaryTimeOff from "./summary-time-off/SummaryTimeOff";
import VStack from "shared/components/layout/stack/VStack";

const UserTimeOff = () => {
    const session = useContext(SessionContext);
    if (session.freelancer || session.contractor) {
        globalThis.location.replace("/timesheets/");
    }

    return (
        <VStack spacing={"Three"}>
            <VStack>
                <SummaryTimeOff />
            </VStack>
            <VStack>
                <MyRequestsTimeOff />
            </VStack>
        </VStack>
    );
};

export default UserTimeOff;
